/****************************************************************************************************
 * 設定
 ****************************************************************************************************/
var isTestUp = false;
var dirTestUp = "/testup/2018/pasumemotv/www/";
var config = {
    dirBase: !isTestUp ? "/" : dirTestUp,
    breakPointS: 736,
    breakPointL: 1024,
    supportAndroid: 5,
    supportIOS: 10,
    supportIE: 11,
};
export default config;
